import MenuBar from "../components/MenuBar";
import TopNavBar from "../components/TopNavBar";
import ViewBoardContainer from "../components/viewBoard/ViewBoardContainer";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import { getCustomerReports, getCustomers, getDbReports } from "../service/apiAccessLogic";
import { msalInstance } from "../index"
import { setAllCustomersID, setCurrentCustomerId, setInvalidCustomerReports, setLastSyncTime, setValidCustomerReports, setValidReports } from "../redux/dataSlice";
import { activateFullScreenPrompt } from "../redux/fullScreenPromptSlice";
import { getSyncTimeString } from "../service/menuLogic";
import Theme from "../Theme";
import ReportBackground from '../resource/DEFEND-Main-Contact.jpg'
import { useEffect, useState } from "react";
import { getFromPath } from "../service/dataLogic";
import { ReportObject } from "../models/ReportModel";

const ReportView = () => {
    const validReports = useAppSelector(state => state.data.validReports)
    const validCustomerReports = useAppSelector(state => state.data.validCustomerReports)
    const companyId = useAppSelector(state => state.user.companyId)
    const currentCustomerId = useAppSelector(state => state.data.currentCustomerId)
    const allCustomersID = useAppSelector((state) => state.data.allCustomersID)
    const currentReport = useAppSelector((state) => state.data.currentReport)
    const generatingReportExports = useAppSelector((state) => state.data.generatingReportExports)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (currentCustomerId === "") return		
        const hasValidReports = validCustomerReports[currentCustomerId] && Object.keys(validCustomerReports[currentCustomerId]).length > 0;
        if (hasValidReports && !generatingReportExports) {
            console.log("Generating report exports: " + generatingReportExports);
            dispatch(activateFullScreenPrompt("false"));
        }
    }, [validCustomerReports])

    const renderMultipage = () => {
        return <div className={`w-full flex flex-col items-center min-h-screen pl-44 bg-cover`} style={{ backgroundImage: `url(${ReportBackground})` }} >
            <TopNavBar />
            <ViewBoardContainer showHeader={true} page={0}/>
            <ViewBoardContainer showHeader={false} page={1}/>
        </div>
    }

    const renderSinglePage = () => {
        return <div className={`w-full flex flex-col items-center min-h-screen pl-44 bg-cover`} style={{ backgroundImage: `url(${ReportBackground})` }} >
            <TopNavBar />
            <ViewBoardContainer showHeader={true}/>
        </div>
    }

    const metadata = currentReport == null ? null : getFromPath(currentReport, "content.metadata") as ReportObject;
    const multipageEnabled = !metadata ? false : metadata["multipage"] as boolean;
    
    return (
        <div className={`flex ${Theme.Colors.DarkWebBg}`} onLoad={async () => {
            if (currentCustomerId === "") {
                dispatch(setCurrentCustomerId(companyId))
            }

            if (allCustomersID.length == 0) {
                dispatch(activateFullScreenPrompt("loading"))
                getCustomers(msalInstance)
                    .then((response) => {
						dispatch(activateFullScreenPrompt("false")); 
                        dispatch(setAllCustomersID(response.data));

                        const customerIds = response.data.map((customer: any) => customer.id);

                        for (const customerId of customerIds) {
                            getCustomerReports(msalInstance, true, customerId).then((response) => {
                                dispatch(setValidCustomerReports({ customerId: customerId, reports: response.data }));
                            }).catch(() => {
                                console.log("Error loading reports for customer: " + customerId);
                            });
                        }
                        for (const customerId of customerIds) {
                            getCustomerReports(msalInstance, false, customerId).then((response) => {
                                dispatch(setInvalidCustomerReports({ customerId: customerId, reports: response.data }));
                            }).catch(() => {
                                console.log("Error loading reports for customer: " + customerId);
                            });
                        }
                    })
                    .catch(() => {
                        console.log("Error loading all customers ID");
                    });
            }

            dispatch(setLastSyncTime({ time: getSyncTimeString(), type: "report" }))
        }}>
            <MenuBar onPage="reportView" hideDisabled={true} />
            {multipageEnabled ? renderMultipage() : renderSinglePage()}
        </div>
    )
}

export default ReportView;